import {Component, inject} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {AsyncPipe} from '@angular/common';
import {RouterLink} from '@angular/router';
import {DropDownButtonComponent} from '../../shared/drop-down-button/drop-down-button.component';
import {ButtonComponent} from '../../shared/button/button.component';
import {OrganizationService} from '../../../services/organization.service';
import {VscodeInstallService} from '../../../services/vscode-install.service';
import {NavigateService} from '../../../services/navigate.service';

@Component({
  selector: 'app-user-menu',
  imports: [
    AsyncPipe,
    RouterLink,
    DropDownButtonComponent,
    ButtonComponent
  ],
  templateUrl: './user-menu.component.html'
})
export class UserMenuComponent {
  protected readonly authService = inject(AuthService)
  protected readonly orgService = inject(OrganizationService)
  protected readonly vscode = inject(VscodeInstallService)
  private readonly navigate = inject(NavigateService)

  protected switchOrganization(orgId: string) {
    this.orgService.setActiveOrganization(orgId);
    this.navigate.home()
  }
}
